import axios from 'axios'
import type { TmsInvoiceWorklistSummary, TmsLoadsReadiness, TmsWorklistPart, TmsWorklistRowsPage } from '@numeo/types-main-web-app'
import { getApiBaseUrlWithoutV1 } from '@/setup/SetupAxios'

// The worklist routes sit at the API root, not under `/v1` (the resource carries its own version).
const WORKLIST_PATH = '/accounting/invoices/worklist/v1'

const WORKLIST_PAGE_SIZE = 20

/** The briefing's counts: one request for every part. */
export async function fetchWorklistSummary(): Promise<TmsInvoiceWorklistSummary> {
    const response = await axios.get<{ success: true; data: TmsInvoiceWorklistSummary }>(WORKLIST_PATH, { baseURL: getApiBaseUrlWithoutV1() })
    return response.data.data
}

interface WorklistRowsQuery {
    page: number
    limit?: number
    search?: string
}

/** One page of a part's rows, exactly from the database. `search` is matched on the server (load #, broker). */
export async function fetchWorklistRows(part: TmsWorklistPart, query: WorklistRowsQuery): Promise<TmsWorklistRowsPage> {
    const response = await axios.get<{ success: true; data: TmsWorklistRowsPage }>(`${WORKLIST_PATH}/${part}`, {
        baseURL: getApiBaseUrlWithoutV1(),
        params: { page: query.page, limit: query.limit ?? WORKLIST_PAGE_SIZE, ...(query.search ? { search: query.search } : {}) },
    })
    return response.data.data
}

/** One named load's readiness, read again for a chat row whose load is no longer on the Ready and needs-documents parts. */
export async function fetchLoadReadiness(loadNumber: string): Promise<TmsLoadsReadiness> {
    const response = await axios.get<{ success: true; data: TmsLoadsReadiness }>(`${WORKLIST_PATH}/readiness`, {
        baseURL: getApiBaseUrlWithoutV1(),
        params: { load_number: loadNumber },
    })
    return response.data.data
}
